export { default } from './CategoriesList'
